
const BrochureButton = require('brochure/Button.js');

function initBrochureButtons(){

	let $btns = $('.btn-brochure');
	let target = window.getParameter('target');
	let trigger = window.getParameter('trigger');
	//console.log("TARGET = ",target);
	$btns.each(function(){
		let $btn = $(this);

		let button = new BrochureButton({
			'$btn': $btn
		})
		if(button.getTarget() == target){
			//console.log("TRIGGER  "+trigger);
			button.trigger(trigger);
		}
	})
}

$(document).ready(function(){
	initBrochureButtons();
});